import { PageContainer } from '../../../components/layout';
import { DashboardHeader } from '../components/DashboardHeader/dashboard-header';
import { Outlet } from 'react-router-dom';

export const DashboardLayoutRoute = () => {
  return (
    <PageContainer>
      <DashboardHeader />
      <Outlet />
    </PageContainer>
  );
};
